var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4351058,10.0628931 L10.7124071,10.0628931 L10.4562607,9.8158948 C11.352773,8.77301315 11.89251,7.41909663 11.89251,5.946255 C11.89251,2.66209262 9.23041738,0 5.946255,0 C2.66209262,0 0,2.66209262 0,5.946255 C0,9.23041738 2.66209262,11.89251 5.946255,11.89251 C7.41909663,11.89251 8.77301315,11.352773 9.8158948,10.4562607 L10.0628931,10.7124071 L10.0628931,11.4351058 L14.6369354,16 L16,14.6369354 L11.4351058,10.0628931 Z M6,10 C3.78666667,10 2,8.21333333 2,6 C2,3.78666667 3.78666667,2 6,2 C8.21333333,2 10,3.78666667 10,6 C10,8.21333333 8.21333333,10 6,10 Z",
    id: "Shape",
    fill: "#333333",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/searchBlack.0eb28abc70a7caf01b89e5ca961d9683.svg";
export { ForwardRef as ReactComponent };